import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={45}
    height={41}
    viewBox='0 0 45 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M39.31 23.548 22.5 39.425l-10.086-8.468-7.845-7.409-3.362-9.526 1.12-7.409L6.81 3.438h8.966L22.5 8.73l2.241-2.117 4.483-3.175 7.845-2.117 6.724 5.292v8.468z'
      fill='#E8EAED'
      stroke='#E8EAED'
    />
  </svg>
);
export default SVGComponent;
